/*
 * @Author: zhaofy
 * @Date: 2018-02-8 22:55:56
 * @Last Modified by: 李志远
 * @Last Modified time: 2022-11-Th 05:32:07
 */
<template>
  <!-- 购物车首页 -->
  <div class="cart">
    <div class="cart-nav">
      <img src="//static.kxymall.com/images/gwc.jpg" alt="购物车及购物车进程" />
    </div>
    <!-- 购物车列表 -->
    <div v-if="cartNums !== 0" class="list">
      <div id="tablebox">
        <span><label for="cart-full-select" class="full-select-title">全选</label><input id="cart-full-select" type="checkbox" class="check all-checkbox" :checked="allSelected" @click="checkAll($event)" /></span>
        <!-- 遍历店铺 -->
        <div v-for="(sItem,index) in storeProduct" :key="index">
          <div style="margin-left:6px">店铺名称：{{filters(sItem.list)}}</div>
          <table cellspacing="0" cellpadding="2" width="100%">
            <tr class="thead">
              <th v-for="item of listTh" :key="item">{{ item }}</th>
            </tr>
            <!-- 遍历店铺中商品 -->
            <tr v-for="(gItem, index) of sItem.list" :key="index">
              <td>
                <input type="checkbox" class="check" :checked="gItem.isCheck" @click="checkEvery($event, gItem)" />
              </td>
              <td @click.stop.prevent="cGoods(gItem.goodsId)">
                <img :src="gItem.imageDefault" alt="购物车商品海报" />
              </td>
              <td v-if="gItem.goodsType === 'batch'" class="name" @click.stop.prevent="cGoods(gItem.goodsId)">
                {{ gItem.goodName }}（批发价商品）
                <br />
                起批量：{{ gItem.batchAmount }}
              </td>
              <td v-else class="name" @click.stop.prevent="cGoods(gItem.goodsId)">
                {{ gItem.goodName }}
                <p v-if="!showSourceFlag && gItem.sourceFlag === 4" style="color: #c00">
                  店长采购专区商品（需要单独支付）
                </p>
                <p v-if="!showSourceFlag && gItem.sourceFlag === 2" style="color: #c00">
                  供应链商品（需要单独支付）
                </p>
              </td>
              <td>￥{{ returnFloat(gItem.marketPrice) }}</td>
              <td>￥{{ returnFloat(gItem.discountPrice) }}</td>
              <td>￥{{ returnFloat(gItem.couponPrice) }}</td>
              <td>
                <span @click="updateNum(gItem, 'reduce')">-</span><input class="num" v-model="gItem.num" type="number" v-on:input="change(gItem)" /><span @click="updateNum(gItem, 'add')">+</span>
              </td>
              <td>{{ returnFloat(gItem.num * gItem.couponPrice) }}</td>
              <td class="name" @click="cDeleteCart(gItem.goodsId)">删除</td>
            </tr>
          </table>
        </div>
      </div>
      <!-- <div class="all-price"><span>商品总价: ￥{{returnFloat(tatalPrice)}}</span></div> -->
      <div class="toolbar-wrap" id="btnbox" :class="stayBottom ? 'fixed-bottom' : 'normal'">
        <div class="options-box">
          <div class="select-all">
            <div class="cart-checkbox">
              <input id="cart-full-selected" type="checkbox" class="check all-checkbox" :checked="allSelected" @click="checkAll($event)" />
            </div>
            <label for="cart-full-selected">全选</label>
          </div>
          <div id="btnbox">
            <div class="btn">
              <div class="clear" @click.stop.prevent="cClear">清空购物车</div>
              <div class="return-buy" @click.stop.prevent="cBuy"></div>
              <div class="checkout" @click.stop.prevent="cCheckout"></div>
            </div>
            <div class="price-sum">
              <div>
                <span class="txt txt-new">总价：</span>
                <span class="price sumPrice">
                  <em>￥{{ returnFloat(tatalPrice) }}</em>
                </span>
                <b class="ml5 price-tips"></b>
              </div>
            </div>
            <!-- 					<div class="amount-sum">
		已选择<em></em>件商品<b class="up" ></b>
	</div> -->
            <div class="clr"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 无数据情况 -->
    <div v-else class="not-list">
      您的购物车中暂无商品，赶快<router-link :to="{ path: '/' }">挑选心爱的商品</router-link>吧！
    </div>
  </div>
</template>
<script>
import { cartCheckV2, updateNumV2, cartBuy } from "api/goodsCart";
import { mapGetters } from "vuex";
import { PRODUCT_SOURCE_FLAG } from "../../api/const";
export default {
  name: "cart",
  data() {
    return {
      isDelete: false, // 是否删除商品的情况下更新了购物车
      storeProduct: [], // 按照店铺分类商品,
      oldStoreProduct: [], // 旧店铺分类商品价格备份
      allSelected: false, // 全选
      isHaveCheck: false, // 是否有选择
      checkids: [], // 选择结算的商品id
      uncheckids: [], // 未选择结算的商品id
      listTh: [
        "选择",
        "图片",
        "商品名称",
        "商品原价",
        "优惠价格",
        "销售价格",
        "数量",
        "小计",
        "删除",
      ],
      showSourceFlag: false, // 是否显示直供专区商品提示

      hasBoundScroll: false,
      stayBottom: false,
    };
  },
  mounted() {
    // 按照店铺整理购物车
    this.getStoreProduct();
    this.bindScroll();
    //初始化界面按钮是否超出可视范围
    setTimeout(() => {
      this.initToolbar();
    }, 500);
  },
  destroyed() {
    $(window).unbind("scroll");
  },
  watch: {
    // 监听购物车商品
    cartProducts() {
      // 删除后重新获取
      if (this.isDelete) this.getStoreProduct();
    },
  },
  computed: {
    // 获取购物车
    ...mapGetters(["cartTotalPrice", "cartNums", "sid", "cartProducts"]
    ),
    // 准备结算的商品总价
    tatalPrice() {
      let tatalPrice = 0;
      this.cartProducts.map((item) => {
        if (item.isCheck) tatalPrice += item.couponPrice * item.num;
      });
      return tatalPrice;
    },
    // 计算是否已登陆
    isLogin() {
      return this.sid && this.sid.length > 0 ? true : false;
    },
  },
  created() {
    this.$store.dispatch("getCartList"); //获取购物车
  },
  methods: {
    // 按照店铺整理购物车
    getStoreProduct() {
      this.storeProduct = []; // 重置为空
      // 设置定时器避免购物车数据还未传入
      let timer = setInterval(() => {
        // 购物车数量需大于0
        if (this.cartProducts.length > 0) {
          this.cartProducts.map((item) => {
            // 遍历所有商品
            if (this.storeProduct.length === 0) {
              // 添加第一个店铺
              this.storeProduct = this.storeProduct.concat({
                storeId: item.storeId, // 店铺id
                storeName: item.storeName, // 店铺名称
                list: [item], // 店铺内商品列表
              });
            } else {
              for (let index in this.storeProduct) {
                // 遍历所有店铺
                if (item.storeId == this.storeProduct[index].storeId) {
                  // 购物车当前商品的店铺是否存在，存在直接添加，不存在新加店铺
                  this.storeProduct[index].list = this.storeProduct[
                    index
                  ].list.concat(item);
                  break;
                } else if (
                  item.storeId != this.storeProduct[index].storeId &&
                  index == this.storeProduct.length - 1
                ) {
                  this.storeProduct = this.storeProduct.concat({
                    storeId: item.storeId,
                    storeName: item.storeName,
                    list: [item],
                  });
                  break;
                }
              }
            }
          });

          if (this.storeProduct) {
            let itemNum = 0,
              chainFlag = 0,
              fristBuyFlag = 0;
            for (const i in this.storeProduct) {
              if (this.storeProduct[i].list) {
                for (const o in this.storeProduct[i].list) {
                  itemNum++;
                  if (
                    this.storeProduct[i].list[o].sourceFlag ===
                    PRODUCT_SOURCE_FLAG.CHAIN
                  ) {
                    chainFlag++;
                  }

                  if (
                    this.storeProduct[i].list[o].sourceFlag ===
                    PRODUCT_SOURCE_FLAG.FIRST_BUY
                  ) {
                    fristBuyFlag++;
                  }
                }
              }
            }

            if (itemNum === chainFlag) {
              //判断是否显示供应链商品混合情况文字提示 全部为直供专区商品不显示提示
              this.showSourceFlag = true;
            }

            if (itemNum === fristBuyFlag) {
              //判断是否首购专区商品混合情况文字提示 全部为首购专区商品不显示提示
              this.showSourceFlag = true;
            }
          }

          // 方式二
          this.oldStoreProduct = JSON.parse(JSON.stringify(this.storeProduct));
          // 整理完毕清除定时器
          clearInterval(timer);
        }
      }, 50);
    },
    // 全选按钮
    checkAll(event) {
      if (!this.allSelected && !this.checkSelectedProducts(true)) {
        // 取消全选
        this.allSelected = false;
        this.$set(event.target, "checked", false);
        return;
      }

      this.allSelected = !this.allSelected;
      let flag = true;
      this.cartProducts.map((item, index) => {
        if (this.allSelected) {
          // 判断当前是否选中并且该批发价商品起批价是否合理
          if (item.goodsType === "batch" && item.num < item.batchAmount) {
            confirm("批发价商品购买数量不能小于起批价");
            flag = false;
            item.isCheck = false;
          } else {
            item.isCheck = true;
          }
        } else {
          item.isCheck = false;
        }
      });

      if (!flag) {
        this.allSelected = false;
      }
    },

    // 单选按钮
    checkEvery(event, gItem) {
      let isAll = true;
      gItem.isCheck = !gItem.isCheck; // 通过isCheck判断是否选择结算

      // 判断当前是否选中并且该批发价商品起批价是否合理
      if (
        gItem.isCheck &&
        gItem.goodsType === "batch" &&
        gItem.num < gItem.batchAmount
      ) {
        confirm("批发价商品购买数量不能小于起批价");
        gItem.isCheck = false;
        this.$set(event.target, "checked", false);
      }

      this.cartProducts.map((item, index) => {
        if (!item.isCheck) isAll = false;
        if (index === this.cartProducts.length - 1 && isAll) {
          this.allSelected = true;
        } else if (index === this.cartProducts.length - 1 && !isAll) {
          this.allSelected = false;
        }
      });

      if (!this.checkSelectedProducts()) {
        gItem.isCheck = false;
        this.$set(event.target, "checked", false);

        if (isAll || this.allSelected) {
          // 取消全选
          isAll = false;
          this.allSelected = false;
          $(".all-checkbox").attr("checked", false);
        }
      }
    },

    // 修改输入框的值
    change(item) {
      if (isNaN(item.num)) {
        confirm("数量只能输入数字，请重新输入");
        if (
          item.sourceFlag === PRODUCT_SOURCE_FLAG.FACTORY_PRICE &&
          item.minBuyNum
        ) {
          item.num = item.minBuyNum;
        } else {
          item.num = 1;
        }
      }
      this.updateNum(item, "input");
    },
    // 更新购物车数量
    updateNum(gItem, type) {
      let currNum = gItem.num;
      const goodsType = gItem.goodsType;
      if (type === "input") {
        if (goodsType === "batch" && gItem.batchAmount > currNum) {
          confirm("批发价商品购买数量不能小于起批价");
          this.storeProduct = JSON.parse(JSON.stringify(this.oldStoreProduct));
        }
      } else if (type === "add") {
        currNum++;
      } else {
        if (goodsType === "batch" && gItem.batchAmount > currNum) {
          confirm("批发价商品购买数量不能小于起批价");
        } else if (
          gItem.sourceFlag === PRODUCT_SOURCE_FLAG.FACTORY_PRICE &&
          gItem.minBuyNum &&
          currNum <= gItem.minBuyNum
        ) {
          confirm("商品购买数量不能小于起购数量");
        } else {
          currNum--;
        }
      }
      //直营精品商品最小起购数量
      if (gItem.sourceFlag === PRODUCT_SOURCE_FLAG.FACTORY_PRICE) {
        if (currNum < gItem.minBuyNum || currNum === "") {
          currNum = gItem.minBuyNum;
          confirm("商品购买数量不能小于起购数量");
        }
      } else {
        // 超出库存或小于0给出提示
        if (currNum < 1 || currNum === "") {
          currNum = 1;
          confirm("至少选择一件");
        }
      }

      if (currNum > gItem.store) {
        currNum = gItem.store;
        confirm("不能超过最大库存");
      }
      // 更新数量
      updateNumV2({
        goodsId: gItem.goodsId,
        goodsNum: currNum,
        promotePurchaseType: ''
      }).then((res) => {
        if (res.resCode === 1) {
          gItem.num = Number(currNum);
          this.oldStoreProduct = JSON.parse(JSON.stringify(this.storeProduct));
          // this.$store.dispatch('updataNum', gItem.goods_id, currNum);
        }
      });
    },
    // 点击商品
    cGoods(id) {
      this.$router.push({ path: "/goods", query: { goods_id: id } });
    },
    // 清空购物
    cClear() {
      this.$store.dispatch("cleanCart");
    },
    // 从购物车中删除
    cDeleteCart(id) {
      //	this.$store.dispatch('deleteCart', id);
      this.$store.dispatch("deleteCart", id).then((res) => {
        if (res.resCode === 1) {
          this.$Message.success("删除商品成功!");
          this.$router.go(0);
        } else {
          this.$Message.info(res.resDesc);
        }
      });
      this.isDelete = true;
      this.initToolbar();
    },
    // 继续购买
    cBuy() {
      this.$router.push({ path: "/" });
    },

    // 校验选中的商品
    checkSelectedProducts(isSeeAll = false) {
      this.checkids.length = 0;
      this.uncheckids.length = 0;
      this.isHaveCheck = false;

      // 以逗号拼接字符串
      let itemNum = 0,
        chainFlag = 0,
        firstBuyFlag = 0,
        officialFlag = 0,
        officialBrandFlag = 0,
        factoryPriceFlag = 0,
        notOfficialFlag = 0; // 非自营商品

      this.cartProducts.map((item) => {
        if (isSeeAll || item.isCheck) {
          itemNum++;

          if (item.sourceFlag === PRODUCT_SOURCE_FLAG.OFFICIAL) {
            officialFlag++;
          }

          if (item.sourceFlag === PRODUCT_SOURCE_FLAG.CHAIN) {
            chainFlag++;
          }

          if (item.sourceFlag === PRODUCT_SOURCE_FLAG.FACTORY_PRICE) {
            factoryPriceFlag++;
          }

          if (item.sourceFlag === PRODUCT_SOURCE_FLAG.FIRST_BUY) {
            firstBuyFlag++;
          }

          if (item.sourceFlag === PRODUCT_SOURCE_FLAG.OFFICIAL_BRAND) {
            officialBrandFlag++;
          }

          if (!item.isSelfRunStore) {
            notOfficialFlag++;
          }

          this.isHaveCheck = true;
          this.checkids.push(item.itemId);
        } else {
          this.uncheckids.push(item.itemId);
        }
      });

      //判断勾选中是否有普通商品和供应链商品
      if (itemNum !== chainFlag && chainFlag) {
        this.$Message.warning("供应链商品（需要单独支付）！");
        return false;
      }

      if (itemNum !== firstBuyFlag && firstBuyFlag) {
        this.$Message.warning("店长采购专区商品（需要单独支付）！");
        return false;
      }

      // 直营出厂价专区和直营品牌专区不能与直营优品和非自营店铺商品一起支付
      if (
        (factoryPriceFlag > 0 || officialBrandFlag > 0) &&
        (officialFlag > 0 || notOfficialFlag > 0)
      ) {
        this.$Message.warning("您所勾选的商品支付方式不同，请分开支付！");
        return false;
      }

      if (itemNum === chainFlag && chainFlag) {
        return {
          sourceFlag: 2,
        };
      } else if (itemNum === officialBrandFlag && officialBrandFlag) {
        return {
          sourceFlag: 5,
        };
      } else if (itemNum === factoryPriceFlag && factoryPriceFlag) {
        return {
          sourceFlag: 3,
        };
      }
      return {};
    },

    // 去结算
    cCheckout() {
      const params = this.checkSelectedProducts();
      if (this.isHaveCheck) {
        if (params) {
          //checkIds 选中的购物车id集合,多个用逗号隔开
          const checkIds = this.checkids.join(",");
          // 未选中的购物车id集合,多个用逗号隔开
          //const uncheckIds = this.uncheckids.join(",");
          //buyFlag 是否为立即购买:0-否,1-是
          const buyFlag = 0
          if (this.checkids.length > 30) {
            this.$Message.warning("不能勾选超过30个商品！");
          } else {
            //调用购物结算接口
            cartBuy({
              buyFlag,
              cartIds: this.checkids,
              //uncheckIds,
            }).then(({ resCode, resDesc, data = {} }) => {
              if (resCode === 1) {
                this.$router.push({
                  path: "/checkout",
                  query: {
                    checkIds,
                    couponLimit: data.checkAtTheCoupon, //重新计算后的购物券
                    selfShoppingPv: data.selfShoppingPv || data.selfRunShoppingPv, //自营购物积分
                    checkAtTheShoppingPv: data.checkAtTheShoppingPv, //重新计算后的自营购物积分
                    coupon: data.coupon, //购物劵
                    chainGoodsProfit: data.chainGoodsProfit,
                    ...params,
                  },
                });
              } else {
                this.$Message.warning(resDesc);
              }
            });
          }
        }
      } else {
        this.$Message.warning("请最少选中一件商品进行结算！");
      }
    },

    // 初始化价格格式
    returnFloat(value) {
      var value = Math.round(parseFloat(value) * 100) / 100;
      var xsd = value.toString().split(".");
      if (xsd.length == 1) {
        if (value >= 1000) {
          var strval = value.toString();
          value =
            strval.substring(0, strval.length - 3) +
            "," +
            strval.substring(strval.length - 3) +
            ".00";
          return value;
        }
        value = value.toString() + ".00";
        return value;
      }
      if (xsd.length > 1) {
        if (xsd[1].length < 2) {
          value = value.toString() + "0";
        }
        return value;
      }
    },
    bindScroll() {
      if (!this.hasBoundScroll) {
        let _this = this;
        this.hasBoundScroll = true;
        $(window).scroll(function (e) {
          //固定操作栏
          const cartlistHeight = $("#tablebox").height();
          const bannerHeight = $("#btnbox").height();
          const windowHeight = $(window).height();
          const scrollTop = $(this).scrollTop();
          // if(cartlistHeight + 152 >= windowHeight){
          _this.stayBottom = cartlistHeight + 152 >= windowHeight;
          //}
          //判断触底
          const documentHeight = $(document).height();

          const hasReachBottom =
            scrollTop + windowHeight + 470 >= documentHeight;
          if (hasReachBottom) {
            _this.stayBottom = false;
          }
        });
      }
    },
    initToolbar() {
      if ($("#btnbox").size()) {
        const bannerTop = $("#btnbox").offset().top;
        const windowHeight = $(window).height();
        if (bannerTop >= windowHeight) {
          this.stayBottom = true;
        } else {
          this.stayBottom = false;
        }
      }
    },
    filters(sItem) {
      let arr = sItem.map(v => v.storeName)
      const set = new Set(arr);
      return [...set].join(',')
    }
  },

  deactivated() {
    this.$destroy();
  },
};
</script>
<style lang="less" scoped>
.cart {
  width: 980px;
  overflow: hidden;
  margin: 0px auto;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type="number"] {
  -moz-appearance: textfield;
}

.cart-nav {
  width: 980px;
  height: 69px;
  overflow: hidden;
  border-top: 1px solid #e7e8e4;
  image {
    width: 980px;
    height: 69px;
  }
}

.check {
  height: 15px;
}

.list {
  width: 978px;
  border: 1px solid #dcdcdc;
  overflow: hidden;
  table {
    border-collapse: collapse;
    border-spacing: 0;
    tr.thead {
      width: 980px;
      height: 24px;
      background-color: #94959d;
      th {
        color: #fff;
        font-weight: normal;
        border-bottom: 1px dashed #bebebe;
        font-weight: bold;
        text-align: center;
      }
    }
    tr {
      td {
        width: 8.5%;
        min-width: 83px;
        text-align: center;
        height: 65px;
        border-bottom: 1px dashed #bebebe;
        img {
          width: 50px;
          height: 50px;
          cursor: pointer;
        }
        span {
          cursor: pointer;
          margin-right: 5px;
          width: 18px;
          height: 18px;
          display: inline-block;
          border: 1px solid #a3b0b9;
          background-color: #fff;
          text-align: center;
          line-height: 18px;
        }
        .num {
          margin: 0px 5px 0px 0px;
          text-align: center;
          width: 26px;
          height: 18px;
          border: 1px solid #a3b0b9;
        }
      }
      td.name {
        cursor: pointer;
        // text-align: left;
        width: 32%;
        &:hover {
          color: #f60;
        }
      }
    }
  }

  .all-price {
    width: 978px;
    height: 42px;
    line-height: 42px;
    border-bottom: 1px dashed #bebebe;
    clear: both;
    span {
      float: right;
      display: inline-block;
      color: #746e6e;
      text-align: right;
      padding-right: 25px;
    }
  }

  .btn {
    /* width: 958px; */
    height: 51px;
    /* padding-top: 16px;  */
    overflow: hidden;
    /* clear: both; */
    padding-right: 20px;
    float: right;
    div {
      display: block;
      text-align: center;
      border: 0px none;
      width: 110px;
      height: 33px;
      float: right;
      overflow: hidden;
      margin: 8.5px 0 8.5px 10px;
      cursor: pointer;
      padding-top: 0px;
      font-size: 14px;
      font-weight: bold;
      color: #fff;
      /* color: #fff; */
      background: url(//static.kxymall.com/images/jshop_button.jpg);
    }
    .checkout {
      background-position: left top;
      &:hover {
        background-position: -138px top;
      }
    }
    .return-buy {
      text-indent: -999px;
      background-position: left -43px;
      &:hover {
        background-position: -138px -43px;
      }
    }
    .clear {
      line-height: 33px;
      background-position: left -88px;
      &:hover {
        background-position: -138px -88px;
      }
    }
  }
}

.not-list {
  padding: 7px 0px;
  a {
    color: #666;
  }
  a:hover {
    color: #f60;
  }
}

.full-select-title {
  padding: 0 6px;
  & + input.check {
    vertical-align: middle;
  }
}
.cart-toolbar {
  height: 50px;
  border: 1px solid #f0f0f0;
  background: #fff;
  position: relative;
}
.toolbar-wrap {
  width: 978px;
  margin: 0 auto;
  .options-box {
    width: 978px;
    margin: 0 auto;
  }
  .select-all {
    float: left;
    height: 18px;
    *width: 60px;
    line-height: 18px;
    padding: 16px 0 16px 9px;
    white-space: nowrap;
    .cart-checkbox {
      position: relative;
      z-index: 3;
      float: left;
      margin-right: 5px;
      .checkbox {
        position: relative;
        float: none;
        vertical-align: middle;
        _vertical-align: -1px;
        margin: 0 3px 0 0;
        *left: -3px;
        padding: 0;
      }
      label {
        display: none;
      }
    }
  }
  .price-sum {
    float: right;
    height: 50px;
    line-height: 50px;
    color: #666;
    width: auto;
    position: relative;
    .txt-new {
      width: 50px;
    }
    .txt {
      float: left;
      width: 50px;
      text-align: right;
      color: #999;
    }
    .price {
      display: inline-block;
      *display: inline;
      *zoom: 1;
      text-align: right;
      font-family: verdana;
      em {
        font-size: 16px;
        color: #e2231a;
        font-weight: 700;
      }
    }
  }
  .amount-sum {
    float: right;
    color: #999;
    height: 50px;
    line-height: 50px;
    cursor: pointer;
    em {
      color: #e2231a;
      font-family: verdana;
      font-weight: 700;
      margin: 0 3px;
    }
  }
}
.fixed-bottom {
  position: fixed;
  background: #fff;
  bottom: 0;
  /*     left: 0; */
  z-index: 999;
  /*     width: 100%; */
  border-width: 1px 0;
  border-top: 1px solid #f0f0f0 \9;
  box-shadow: 0 -1px 8px rgba(0, 1, 1, 0.08);
}
.normal {
  position: inherit;
}
.hide {
  display: none;
}
.clear,
.clr {
  display: block;
  overflow: hidden;
  clear: both;
  height: 0;
  line-height: 0;
  font-size: 0;
}
</style>
<style lang="less">
.cart {
  .ivu-checkbox-inner {
    width: 12px;
    height: 12px;
    border-color: #999;
    background-color: #ddd;
  }
  .ivu-checkbox-focus {
    box-shadow: none;
  }
  .ivu-checkbox-checked .ivu-checkbox-inner {
    border-color: #999;
    background-color: #ddd;
  }
  .ivu-checkbox-checked:hover .ivu-checkbox-inner {
    border-color: #999;
  }
  .ivu-checkbox-checked .ivu-checkbox-inner:after {
    border-color: #333;
  }
}
</style>






// WEBPACK FOOTER //
// index.vue?3c7f4ec5